import { Component, OnInit }         from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter }                    from 'rxjs/operators';
import { MicroenterpriseAdminService } from '../services/microenterprise-admin.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  showVicAddress = true;

  constructor(
    public microenterpriseAdminService: MicroenterpriseAdminService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        const deepest = this.getDeepestChild(this.activatedRoute);
        // if route.data.region exists, hide VIC address
        this.showVicAddress = !deepest.snapshot.data['region'];
      });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    return route.firstChild
      ? this.getDeepestChild(route.firstChild)
      : route;
  }
}
